<div class="formfield">
    <label for="issuerList" class="issuer-label">
      {{ "AGREEMENT.INPUT.ISSUER.LABEL" | translate }}
    </label>
    <select
      [cypress]="'issuer'"
      (ngModelChange)="selected.emit($event)"
      [(ngModel)]="selectedIssuerId"
      class="issuer-select"
      id="issuerList"
    >
      <option value="0" disabled>
        {{ "AGREEMENT.INPUT.ISSUER.DROPDOWN.CHOOSE" | translate }}
      </option>
      <option *ngFor="let issuer of issuers" [value]="issuer.id">
        {{ issuer.displayName }}
      </option>
    </select>

  <div *ngIf="issuerRequiredError">
    <nes-message-inline type="error" class="nes-mt-10">
      {{ "AGREEMENT.INPUT.ISSUER.ERROR_REQUIRED" | translate }}
    </nes-message-inline>
  </div>
</div>
